import CheckIcon from '@mui/icons-material/Check';
import SortIcon from '@mui/icons-material/Sort';
import { Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { useState } from 'react';

type DashboardMyAccountsSortMenuButtonProps = {
    sortBy: string;
    setSortBy: (value: string) => void;
    sortDirection: 'asc' | 'desc';
    setSortDirection: (value: 'asc' | 'desc') => void;
};

const DashboardMyAccountsSortMenuButton = ({
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
}: DashboardMyAccountsSortMenuButtonProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const isOpen = Boolean(anchorEl);

    const sortOptions: Array<{ value: string; label: string }> = [
        { value: 'username', label: 'Username' },
        { value: 'email', label: 'Email' },
        { value: 'credit', label: 'Credit' },
        { value: 'fans', label: 'Fans' },
        { value: 'following', label: 'Following' },
        { value: 'ranking', label: 'Ranking' },
        { value: 'earnings', label: 'Earnings' },
        { value: 'isLoggedIn', label: 'Logged In' },
    ];

    const directionOptions: Array<{ value: 'asc' | 'desc'; label: string }> = [
        { value: 'asc', label: 'Ascending' },
        { value: 'desc', label: 'Descending' },
    ];

    return (
        <>
            <IconButton
                onClick={event => setAnchorEl(event.currentTarget)}
                size="small"
                color={sortBy === 'username' && sortDirection === 'asc' ? 'primary' : 'secondary'}
                sx={{
                    bgcolor: 'transparent',
                    mb: 0,
                    mt: 0,
                }}
            >
                <SortIcon fontSize="small" />
            </IconButton>
            <Menu anchorEl={anchorEl} open={isOpen} onClose={() => setAnchorEl(null)}>
                <Typography variant="body2" sx={{ px: 2, pb: 1 }}>
                    Sort By
                </Typography>
                {sortOptions.map(option => (
                    <MenuItem
                        key={option.value}
                        selected={option.value === sortBy}
                        onClick={() => {
                            setSortBy(option.value);
                            setAnchorEl(null);
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 32 }}>{option.value === sortBy ? <CheckIcon fontSize="small" /> : null}</ListItemIcon>
                        <ListItemText>{option.label}</ListItemText>
                    </MenuItem>
                ))}
                <Divider />
                {directionOptions.map(option => (
                    <MenuItem
                        key={option.value}
                        selected={option.value === sortDirection}
                        onClick={() => {
                            setSortDirection(option.value);
                            setAnchorEl(null);
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 32 }}>
                            {option.value === sortDirection ? <CheckIcon fontSize="small" /> : null}
                        </ListItemIcon>
                        <ListItemText>{option.label}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default DashboardMyAccountsSortMenuButton;
